var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login-reg" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "log-box main" }, [
          _c(
            "form",
            {
              staticClass: "gen-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.selectPkg($event)
                }
              }
            },
            [
              _c("h2", [_vm._v("Access replays of live events")]),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "subpage-head" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v("Subscribe now!")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-act" }, [
      _c("button", { staticClass: "lbtn" }, [_vm._v("Subscribe now")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }